import { State } from '../model';

export const stateDiffers = (s1: State, s2: State) => {
  return s1.narration !== s2.narration || s1.rpc !== s2.rpc;
};
